<template>
  <MainTab
    :main-title="mainTitle"
    :confirm-button-text="confirmButtonText"
    :action="actionSelected"
    :condition="enableButton"
  >
    <ContentWrapper>
      <template #header>
        <p class="dea-heading--medium__m">
          Il tuo attestato riporterà il nome e cognome qui sotto riportato; se i dati non sono corretti clicca su
          Modifica il tuo profilo
        </p>
        <Buttons type="a" :href="`${config.profile_user}?url=${url}`" class="dea-button--small" icon="edit"
          >Modifica Profilo</Buttons
        >
      </template>
      <template #default>
        <PersonalData :user="user">
          <template v-if="checkFcAndSofia">
            <div class="xs-12 m-6 form-container">
              <FiscalCodeConfirmation
                :fiscal-code-placeholder="localFiscalCode"
                title-class="dea-heading--medium__xm"
                :is-disabled="skipFc ? 'true' : 'false'"
                :show-checkbox="false"
                @change-checkbox="changeCheckbox"
              ></FiscalCodeConfirmation>
            </div>
            <div class="xs-12 m-6 data-container__block data-container__block--margin-top">
              <p class="dea-heading--medium__xm">&nbsp;</p>
              <div class="dea-heading--regular__xs">
                Perchè ti stiamo chiedendo il codice fiscale? Per completare il tuo attestato su S.O.F.I.A., qualora tu
                ne abbia diritto.
              </div>
            </div>
          </template>
          <template v-else>
            <div></div>
          </template>
        </PersonalData>
        <Modal
          :visible="modalVisible"
          class="dea-modal--completed-survey dea-modal--no-footer"
          @modalClose="closeModal()"
        >
          <template #content>
            <div v-if="certificateUrl">
              <div class="dea-heading--regular__ms completed-survey__text">
                Hai già completato il questionario, torna ai Corsi a cui hai partecipato e scarica il tuo attestato!
              </div>
              <Buttons
                :href="certificateUrl"
                type="a"
                target="_blank"
                class="dea-button--small dea-button--iconLeft"
                icon="download"
                >Scarica attestato
              </Buttons>
            </div>
            <div v-else>
              <div class="dea-heading--regular__ms completed-survey__text">
                Hai già completato il questionario, ma il tuo attestato non è ancora disponibile. Ti avvisiamo noi con
                una mail appena sarà disponibile
              </div>
              <Buttons
                :href="$root.config.myevents_url"
                type="a"
                target="_blank"
                class="dea-button--small dea-button--iconLeft"
                >Vai a I miei eventi
              </Buttons>
            </div>
          </template>
        </Modal>
      </template>
    </ContentWrapper>
  </MainTab>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Buttons from "@/components/elements/Buttons";
import Modal from "@/components/patterns/Modal";
import { createFocusTrap } from "focus-trap";
import MainTab from "~/components/events/components/MainTab";
import ContentWrapper from "~/components/events/components/ContentWrapper";
import PersonalData from "~/components/events/components/PersonalData";
import FiscalCodeConfirmation from "~/components/events/components/FiscalCodeConfirmation";

export default {
  name: "EventsPersonalData",
  components: {
    Buttons,
    MainTab,
    Modal,
    ContentWrapper,
    PersonalData,
    FiscalCodeConfirmation,
  },
  props: {
    mainTitle: {
      type: String,
      default: "",
    },
    confirmButtonText: {
      type: String,
      default: "Conferma e prosegui",
    },
  },
  data() {
    return {
      showModal: false,
      skipFc: false,
      focusTrap: null,
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "config",
      "fiscalCode",
      "activeRegistration",
      "localFiscalCode",
      "isFCWrong",
      "registrationIsLoaded",
      "registrations",
      "userFiscalCode",
    ]),
    url() {
      return encodeURIComponent(document.location);
    },
    userRegistration() {
      return this.activeRegistration() || {};
    },
    userHasFc() {
      return this.userFiscalCode;
    },
    sofiaRegistration() {
      return (
        this.userRegistration && this.userRegistration.linked_event && this.userRegistration.linked_event.sofia
        // this.userRegistration.is_sofia_limit_reached
      );
    },
    checkFcAndSofia() {
      return !this.userHasFc && this.sofiaRegistration;
    },
    enableButton() {
      if (this.checkFcAndSofia) {
        if (this.skipFc || (this.localFiscalCode.length === 16 && !this.isFCWrong)) {
          return true;
        }
        return false;
      }
      return true;
    },
    showAlreadyCompletedSurveyModal() {
      if (this.registrationIsLoaded) {
        if (this.activeRegistration().survey_completed_date) {
          this.openModal();
          return true;
        }
      }
      this.closeModal();
      return false;
    },
    certificateUrl() {
      if (this.userRegistration) return this.userRegistration.dea_certificate_url;
      return null;
    },
    modalVisible() {
      return this.showAlreadyCompletedSurveyModal && this.showModal;
    },
  },
  watch: {
    modalVisible(val) {
      if (val) {
        this.$nextTick(() => {
          const modalEl = this.$el.querySelector(".dea-modal--completed-survey");
          if (!modalEl) return;

          if (this.focusTrap === null) {
            this.focusTrap = createFocusTrap(modalEl, {
              onDeactivate: () => {
                this.closeModal();
              },
              onPostDeactivate: () => {
                this.focusTrap = null;
              },
              escapeDeactivates: true,
              allowOutsideClick: true,
            });
            this.focusTrap.activate();
          }
        });
      } else if (this.focusTrap) {
        this.focusTrap.deactivate();
      }
    },
  },
  beforeDestroy() {
    if (this.focusTrap) this.focusTrap.deactivate();
  },
  beforeMount() {
    this.updateRegistrationLoading(false);
    this.fetchRegistration({ registrationId: this.$route.params.registration, force: true });
  },
  methods: {
    ...mapActions(["fetchRegistration", "storeFCOnly"]),
    ...mapMutations(["updateRegistrationLoading"]),
    confirmData() {
      this.$router.push({ name: "survey", params: { registration: this.$route.params.registration } });
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    changeCheckbox(e) {
      this.skipFc = e;
    },
    actionSelected() {
      if (this.checkFcAndSofia && !this.skipFc) {
        this.storeFCOnly();
      }
      this.confirmData();
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.form-container {
  p {
    margin: 1em 0 0 !important; //sass-lint:disable-line no-important
    text-transform: uppercase;
  }
}

.completed-survey__text {
  margin-bottom: $space-small;
}

.checkbox-fc {
  .dea-checkbox__label {
    max-width: none;
  }
}
</style>
